import gql from "graphql-tag";
import { getTotal, groupByFn, removeGQLTypename } from "../../../../../helpers";
import EventBus from "../../../../../store/event-bus";

const SUPPLIER_COMPS_QUERY = gql`
  query supplierComps($id: ID!) {
    supplierComps(id: $id) {
      edges {
        node {
          id
          supplierId
          paxFrom
          paxTo
          pass
          free
          serviceId
          supplier {
            id
            name
          }
          service {
            id
            name
          }
        }
      }
    }
  }
`;
//items added from search carry AvailableSupplier ids, comps carry Supplier ids - compare by record id (#11495)
const rawId = (id) => {
  try {
    return atob(id).split("-").pop();
  } catch (e) {
    return id;
  }
};
export default {
  data() {
    return {
      lastAddedSupplierId: "",
      showItiCompsDialog: false,
      comps: [],
      basicComps: false,
    };
  },

  computed: {
    supplierCompsItems() {
      return this.supplierComps && this.supplierComps.edges
        ? this.supplierComps.edges
            .map(removeGQLTypename)
            .map((sc) => ({ ...sc, supplierCompId: sc.id }))
        : [];
    },
  },

  methods: {
    onShowItiComps() {
      this.showItiCompsDialog = true;
    },
    updateCompsBySupplierAndStay() {
      //group by suppliers stay
      const itemsFilter = (item) => {
        return (
          item.serviceTypeName != "MANDATORY_CHARGES" &&
          item.isIncluded &&
          item.status.toLowerCase().indexOf("cancel") < 0
        );
      };
      const updates = {};
      const suppliersStays = groupByFn(
        this.items.filter(itemsFilter),
        (item) =>
          `${rawId(item.supplierId)}|${item.startDate
            .toString()
            .substring(0, 10)}|${item.endDate.toString().substring(0, 10)}`
      );
      for (const k of Object.keys(suppliersStays)) {
        const itemsForStay = suppliersStays[k];
        const paxForStay = getTotal(
          itemsForStay,
          (item) => Number(item.adults) + Number(item.children)
        );
        for (const item of itemsForStay) {
          const applicableComps = this.comps.filter(
            (c) =>
              paxForStay >= c.paxFrom &&
              paxForStay <= c.paxTo &&
              rawId(c.supplier.id) == rawId(item.supplierId) &&
              c.service.id == item.serviceId
          );
          if (applicableComps.length > 0) {
            const compToApply = applicableComps[0];
            updates[item.id] = compToApply;
          }
        }
      }

      //apply updates
      for (let i = 0; i < this.items.length; i++) {
        const item = this.items[i];
        if (updates[item.id]) {
          const comp = updates[item.id];
          Object.assign(this.items[i], {
            ...this.items[i],
            supplierComp: comp.free,
            passComp: comp.pass,
          });
        } else {
          Object.assign(this.items[i], {
            ...this.items[i],
            supplierComp: 0,
            passComp: 0,
          });
        }
      }

      //console.log(updates);
    },
    updateCompsByService() {
      for (let i = 0; i < this.items.length; i++) {
        const item = this.items[i];
        const pax = Number(item.adults) + Number(item.children);

        const applicableComps = this.comps.filter(
          (c) =>
            pax >= c.paxFrom &&
            pax <= c.paxTo &&
            rawId(c.supplier.id) == rawId(item.supplierId) &&
            c.service.id == item.serviceId
        );
        //console.log(`${item.serviceName}`, pax, applicableComps);
        if (applicableComps.length > 0) {
          const compToApply = applicableComps[0];
          //applying comp
          Object.assign(this.items[i], {
            ...this.items[i],
            supplierComp: compToApply.free,
            passComp: compToApply.pass,
          });
        } else {
          Object.assign(this.items[i], {
            ...this.items[i],
            supplierComp: 0,
            passComp: 0,
          });
        }

        // if (this.items[i].supplierId == suppId) {
        //   Object.assign(this.items[i], {
        //     ...this.items[i],
        //     supplierComp: 0,
        //     passComp: 0,
        //   });
        // }
      }
    },
    updateComps() {
      //console.log("updating comps");
      //
      if (
        this.$store.getters.hasAccessTo("suppliers:comps_service_level", false)
      ) {
        this.updateCompsByService();
      } else {
        this.updateCompsBySupplierAndStay();
      }
      return;
      const suppliersWithComps = [
        ...new Set(this.comps.map((c) => c.supplier.id)),
      ];
      for (const suppId of suppliersWithComps) {
        const pax = this.getPaxForSupplier(suppId);
        const supplierServices = this.items
          .filter((item) => item.supplierId == suppId)
          .map((item) => item.serviceId);
        //clear current comps
        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].supplierId == suppId) {
            Object.assign(this.items[i], {
              ...this.items[i],
              supplierComp: 0,
              passComp: 0,
            });
          }
        }
        const applicableComps = this.comps.filter(
          (comp) =>
            pax >= comp.paxFrom &&
            pax <= comp.paxTo &&
            supplierServices.indexOf(comp.service.id) > -1
        );

        if (applicableComps.length > 0) {
          //sort by priority later
          const comp = applicableComps[0]; //apply first one

          const serviceToUpdate = this.items.find(
            (item) => item.serviceId == comp.serviceId
          );
          const itemIndex = this.items.findIndex(
            (item) => item.serviceId == comp.serviceId
          );
          Object.assign(this.items[itemIndex], {
            ...serviceToUpdate,
            supplierComp: comp.free,
            passComp: comp.pass,
          });
        }
      }
    },
    checkForApplicableComps() {
      //console.log("checkForApplicableComps");
      this.updateComps();
      // if (this.supplierCompsItems.length > 0) {
      //   const pax = this.getPaxForSupplier();
      //   const supplierServices = this.items
      //     .filter((item) => item.supplierId == this.lastAddedSupplierId)
      //     .map((item) => item.serviceId);
      //   //clear current comps
      //   for (let i = 0; i < this.items.length; i++) {
      //     if (this.items[i].supplierId == this.lastAddedSupplierId) {
      //       //console.log("updating", this.items[i].supplierName);
      //       Object.assign(this.items[i], {
      //         ...this.items[i],
      //         supplierComp: 0,
      //         passComp: 0,
      //       });
      //     }
      //   }
      //   const applicableComps = this.supplierCompsItems.filter(
      //     (comp) =>
      //       pax >= comp.paxFrom &&
      //       pax <= comp.paxTo &&
      //       supplierServices.indexOf(comp.serviceId) > -1
      //   );
      //   if (applicableComps.length > 0) {
      //     //sort by priority later
      //     const comp = applicableComps[0]; //apply first one

      //     const serviceToUpdate = this.items.find(
      //       (item) => item.serviceId == comp.serviceId
      //     );
      //     const itemIndex = this.items.findIndex(
      //       (item) => item.serviceId == comp.serviceId
      //     );
      //     Object.assign(this.items[itemIndex], {
      //       ...serviceToUpdate,
      //       supplierComp: comp.free,
      //       passComp: comp.pass,
      //     });
      //   }
      // }
    },
    getPaxForSupplier(supplierId = null) {
      const id = supplierId ? supplierId : this.lastAddedSupplierId;
      //console.log(this.items.filter((item) => item.supplierId == id));
      return this.items
        .filter((item) => item.supplierId == id)
        .reduce(
          (t, item) => (t += Number(item.adults) + Number(item.children)),
          0
        );
    },
    compToItiInput(comp) {
      return {
        paxFrom: comp.paxFrom,
        paxTo: comp.paxTo,
        supplierId: comp.supplierId,
        serviceId: comp.serviceId,
        free: comp.free,
        pass: comp.pass,
        supplierCompId: comp.supplierCompId,
      };
    },
    onCompsInput(payload) {
      this.showItiCompsDialog = false;
      //this.checkForApplicableComps();
      this.updateComps();
      EventBus.$emit("iti-items-refresh");
    },
  },

  apollo: {
    supplierComps: {
      query: SUPPLIER_COMPS_QUERY,
      variables() {
        return { id: this.lastAddedSupplierId };
      },
      skip() {
        return this.lastAddedSupplierId == "";
      },
      result({ data }) {
        //add to iti comps
        //console.log("adding comps", data.supplierComps.edges);
        if (data.supplierComps.edges) {
          for (const suppComp of data.supplierComps.edges
            .map(removeGQLTypename)
            .map((sc) => ({ ...sc, supplierCompId: sc.id }))) {
            if (
              this.comps.findIndex((ic) => ic.supplierCompId == suppComp.id) ==
              -1
            ) {
              this.comps.push(suppComp);
            }
          }
        }
        //auto apply comps
        this.checkForApplicableComps();
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/gt/itineraries/builder/mixins/supplier-comps.js